export class CourseDogRegistrationInfoDto {
  //dog_id: string;
  breed: string;
  variety?: string;
  variation?: string;
  sex: string;
  dob?: Date;
  weight?: number;

  registered_name: string;
  call_name: string;
  prefix_title?: string;
  suffix_title?: string;

  country_of_birth?: string;

  breeder?: string;
  dam?: string;
  sire?: string;

  sessions?: string[];
}
